export const DownArrowIcon = ({
  size = 12,
  color = 'currentColor',
  ...rest
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}>
    <path d="M7 7.5L6.11959e-07 0.499998L14 0.5L7 7.5Z" fill={color} />
  </svg>
);
